import { loadingSx } from '@/components/content/Global/styles/loading';
import { useLoading } from '@/data/context/loadingContext';
import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';
/**
 * Global blocking loading indicator
 * @returns
 */
const GlobalLoadingIndicator: React.FC = () => {
	const { isLoading } = useLoading();
	return (
		<Backdrop sx={loadingSx} open={isLoading}>
			<CircularProgress color="inherit" />
		</Backdrop>
	);
};

export default GlobalLoadingIndicator;
